import {
  createUser,
  createUserPermissions,
  fetchProfile,
  getPermissionList,
  getUsers,
  saveProfile,
  setUserLocked
} from "../api/users";
import {DUPLICATE_USER_ERROR, INCORRECT_CURRENT_PASSWORD_ERROR, validateUserForm} from "../utils/users";
import {sendInvite} from "../api/users";
import {updateSessionId} from "./session";
import {checkResponseError, dispatchError} from "../utils";
import {validateChangePasswordForm} from "../utils/session";
import {changePwd, forgotPwd} from "../api/session";
import {CREATE_USER_UC_OBJECT, SAVE_PERMISSIONS_USER_COMPOSITE_BASE} from "../constants";

const initialState = {
  users: [],
  fetchUsersError: null,
  userFormErrors: null,
  saveMyProfileErrors: null,
  fetchMyProfileErrors: null,
  saveUserProfileErrors: null,
  saveUserProfileSuccess: null,
  createUserErrors: null,
  createUserSuccess: null,
  myProfile: null,
  createdUser: null,
  createUserCurrentStep: 'user-info',
  saveUserPermissionsApiSuccess: null,
  saveUserPermissionsApiFailure: null,
  myUser: null,
  managedUser: null,
  changePasswordErrors: null,
  changePasswordSuccess: null,
  changePasswordApiErrors: null,
  sendInviteSuccess: null,
  sendInviteApiError: null,
  sendUserProfileResetPasswordSuccess: null,
  sendUserProfileResetPasswordError: null,
  sendUserProfileResetPasswordApiFailure: null,
  permissionsList: null,
  permissionsListApiErrors: null
}

export const sendInviteEmail =  (currentUser, userToInvite) => async(dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: currentUser.username,
    sessionId: state.session.sessionData,
    emailAddress: userToInvite.username
  }

  try {
    const response = await(sendInvite(queryParams));

    dispatch ({
      type: 'users/sendInvite',
      payload: userToInvite
    });
    dispatch(updateSessionId(response.loggedInUserSessionId));
  } catch (error) {
    await dispatchError(error, {
      type: 'users/sendInviteApiFailed',
      payload: error
    }, dispatch);
  }

}

export const sendUserProfilePasswordReset = (userToSend) => async(dispatch, getState) => {
    try {
      const response = await(forgotPwd(userToSend.username));

      if (response === true) {
        dispatch ({
          type: 'users/sendUserProfileResetPasswordSuccess',
          payload: userToSend
        });
      } else {
        dispatch ({
          type: 'users/sendUserProfileResetPasswordError',
          payload: response
        })
      }
    } catch (error) {
      dispatch({
        type: 'users/sendUserProfileResetPasswordApiFail',
        payload: error
      });
    }
}

export const fetchUsers = () => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUser: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  try {
    const users = await getUsers(queryParams);
    const firstRecord = users[0];

    if (checkResponseError(firstRecord)) {
      dispatch({
        'type': 'users/usersFetched',
        payload: users
      });
    } else {
      dispatch ({
        type: 'users/fetchUsersFailed',
        payload: firstRecord.error
      })
    }

    dispatch(updateSessionId(users[0].loggedInUserSessionId));
  } catch (error) {
    await dispatchError(error, {
      type: 'users/fetchUsersFailed',
      payload: error
    }, dispatch);
  }
}

export const fetchMyProfile = (myUser) => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUser: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  try {
    const myProfile = await fetchProfile(queryParams, myUser);

    if (checkResponseError(myProfile.user)) {
      dispatch({
        'type': 'users/fetchMyProfileSuccess',
        payload: myProfile
      });
    } else {
      dispatch ({
        'type': 'users/fetchMyProfileError',
        payload: myProfile
      })
    }
    dispatch(updateSessionId(myProfile.user.loggedInUserSessionId));
  } catch (error) {
    await dispatchError(error, {
      type: 'users/fetchMyProfileApiFailed',
      payload: error
    }, dispatch);
  }
}

export const getManagedUser = () => {
  const managedUser = getManagedUserFromLocalStorage();

  return {
    type: 'users/getManagedUser',
    payload: managedUser
  }
}

export const setManagedUser = (managedUser) => {
  storeManagedUserInLocalStorage(managedUser);

  return {
    type: 'users/setManagedUser',
    payload: managedUser
  }
}

export const clearManagedUser = () => {
  clearManagedUserInLocalStorage();

  return {
    type: 'users/clearManagedUser'
  }
}

export const clearFetchUsersErrors = () => {
  return {
    type: 'users/clearFetchUsersErrors'
  }
}

export const getManagedUserFromLocalStorage = () => {
  return localStorage.getItem('managedUser');
};

export const storeManagedUserInLocalStorage = (managedUser) => {
  localStorage.setItem('managedUser', managedUser);
};

export const clearManagedUserInLocalStorage = () => {
  localStorage.removeItem('managedUser');
};

//  To save a generic profile
export const saveUserProfile = (formData, userProfile) => async (dispatch, getState) => {
  const formErrors = validateUserForm(formData);

  const roleId = parseInt(formData.role);
  const programId = parseInt(formData.programAssociation);

  const state = getState();

  const permissionsList = state.users.permissionsList;

  const queryParams = {
    loggedInUser: state.session.currentUser.username,
    sessionId: state.session.sessionData,
    userName: userProfile.user.username
  }

  function setUserProfileData() {
    userProfile.user.firstName = formData.firstName;
    userProfile.user.lastName = formData.lastName;
    userProfile.user.roleId = roleId;
    userProfile.user.programId = programId;
    userProfile.userRole = userProfile.userRoleList.find(element => element.id === roleId);
    userProfile.program = userProfile.programList.find(element => element.id === programId);
    userProfile.user.enabled = formData.enabled;
    userProfile.user.accountLocked = formData.locked;

    if (formData.superUser) {
      userProfile['userPermission'] = buildUserPermissionObject(userProfile.user, 'ROLE_PERMISSION_SUPER_USER', permissionsList);
    }
  }

  if (formErrors) {
    dispatch({
      type: 'users/saveMyProfileFailedValidation',
      payload: formErrors
    });

    return null;
  }

  try {

    setUserProfileData();

    const userObject = await saveProfile(queryParams, userProfile);

    let newSessionId = userObject.loggedInUserSessionId;

    if (userProfile.user.accountLocked !== formData.locked) {
      const userLockedQueryParams = {
        loggedInUserName: state.session.currentUser.username,
        sessionId: newSessionId,
        userId: userProfile.user.id,
        lockFlag: formData.locked
      }

      const lockedResponse = await setUserLocked(userLockedQueryParams);

      newSessionId = await lockedResponse.loggedInUserSessionId;
    }

    if (checkResponseError(userObject)) {
      await dispatch(updateSessionId(newSessionId));
      await dispatch({
        'type': 'users/saveUserProfileApiSuccess',
        payload: {
          userProfile: userProfile,
        }
      });
    } else {
      await dispatch ({
        'type': 'users/saveUserProfileApiFailure',
        payload: userObject.apiError
      })
    }

  } catch (error) {
    await dispatchError(error, {
      type: 'users/saveUserProfileApiFailure',
      payload: 'Api Error with Save User Profile'
    }, dispatch);
  }
}


export const createUserProfile = (formData) => async (dispatch, getState) => {
  const formErrors = validateUserForm(formData, true);

  const roleId = (formData.role) ? parseInt(formData.role) : null;
  const programId = (formData.programAssociation) ? parseInt(formData.programAssociation) : null;

  const state = getState();

  const queryParams = {
    loggedInUser: state.session.currentUser.username,
    sessionId: state.session.sessionData,
  }

  function addFormDataToUserObject(formData, userProfile) {
    userProfile.username = formData.email;
    userProfile.firstName = formData.firstName;
    userProfile.lastName = formData.lastName;
    userProfile.roleId = roleId;
    userProfile.programId = programId;
  }

  if (formErrors) {
    dispatch({
      type: 'users/createUserFailedValidation',
      payload: formErrors
    });

    return null;
  }

  const userProfile = CREATE_USER_UC_OBJECT;

  addFormDataToUserObject(formData, userProfile);

  try {

    const userObject = await createUser(queryParams, userProfile);

    if (checkResponseError(userObject)) {
      dispatch({
        'type': 'users/createUserApiSuccess',
        payload: {
          userProfile: userObject,
        }
      });
    } else {
      dispatch ({
        'type': 'users/createUserApiFailure',
        payload: userObject.apiError
      })
    }

    dispatch(updateSessionId(userObject.loggedInUserSessionId));
  } catch (error) {

    if (error.cause === 'INVALID_USER_EXIST') {
      const formError = {
        email: [
          `${formData.email} ${DUPLICATE_USER_ERROR}`
        ]
      };

      dispatch ({
        type: 'users/createUserFailedValidation',
        payload: formError
      })
    } else {
      await dispatchError(error,{
        type: 'users/createUserApiFailure',
        payload: 'Api Error with Creating a User'
      }, dispatch);
    }
  }
}

export const saveMyProfile = (profileForm, myProfile, myUser) => async (dispatch, getState) => {
  const formErrors = validateUserForm(profileForm);

  const roleId = parseInt(profileForm.role);
  const programId = parseInt(profileForm.programAssociation);

  const state = getState();

  const queryParams = {
    loggedInUser: myUser.username,
    sessionId: state.session.sessionData,
    userName: myProfile.user.username
  }

  function setMyProfileData() {
    myProfile.user.firstName = profileForm.firstName;
    myProfile.user.lastName = profileForm.lastName;
    myProfile.user.roleId = roleId;
    myProfile.user.programId = programId;
    myProfile.userRole = myProfile.userRoleList.find(element => element.id === roleId);
    myProfile.program = myProfile.programList.find(element => element.id === programId);
  }

  function setMyUserData() {
    myUser.firstName = profileForm.firstName;
    myUser.lastName = profileForm.lastName;
    myUser.roleId = roleId;
    myUser.programId = programId;
  }

  if (formErrors) {
    dispatch({
      type: 'users/saveMyProfileFailedValidation',
      payload: formErrors
    });

    return null;
  }

  try {

    setMyProfileData();

    const userObject = await saveProfile(queryParams, myProfile);

    await setMyUserData();

    if (checkResponseError(userObject)) {
      dispatch({
        'type': 'users/saveMyProfileApiSuccess',
        payload: {
          myProfile: myProfile,
          myUser: myUser
        }
      });
    } else {
      dispatch ({
        'type': 'users/saveMyProfileApiFailure',
        payload: userObject.error
      })
    }

    dispatch(updateSessionId(userObject.loggedInUserSessionId));
  } catch (error) {
    await dispatchError(error, {
      type: 'users/saveMyProfileApiFailure',
      payload: 'Api Error with Save My Profile'
    }, dispatch);
  }
}

function buildUserPermissionObject(user, permissionLevel, permissionsList) {
  const permissionLevelObject = permissionsList.find((permission) => permission.authority === permissionLevel);

  return {
    userId:  user.id,
    permissionId: permissionLevelObject.id
  }
}

export const saveUserPermissions = (user, permissions, sendInviteToUser) => async (dispatch, getState) => {
  const state = getState();

  const permissionsList = state.users.permissionsList;

  const queryParams = {
    loggedInUser: state.session.currentUser.username,
    sessionId: state.session.sessionData,
  }

  const userCompositeObject = SAVE_PERMISSIONS_USER_COMPOSITE_BASE;

  const permissionLevel = permissions.permissionLevel;

  userCompositeObject['user'] = user;
  userCompositeObject['userPermission'] = buildUserPermissionObject(user, permissionLevel, permissionsList);
  userCompositeObject['districtList'] = permissions.districts;
  userCompositeObject['schoolList'] = permissions.schools;

  try {
    const userObject = await createUserPermissions(queryParams, userCompositeObject);

    let nextSessionId = userObject.loggedInUserSessionId;

    if (sendInviteToUser === true) {
      const sendInviteUserParams = {
        loggedInUserName: queryParams.loggedInUser,
        sessionId: userObject.loggedInUserSessionId,
        emailAddress: user.username
      }

      try {
        const sendInviteObject = await sendInvite(sendInviteUserParams);

        nextSessionId = sendInviteObject.loggedInUserSessionId;

      } catch (error) {
        dispatch({
          type: 'users/saveUserPermissionsApiFailure',
          payload: 'Api Error with Save User Permissions - Send Invite'
        });
      }
   }

    dispatch({
      'type': 'users/saveUserPermissionsApiSuccess',
    });

    dispatch(updateSessionId(nextSessionId));
  } catch (error) {
    await dispatchError(error, {
      type: 'users/saveUserPermissionsApiFailure',
      payload: 'Api Error with Save User Permissions'
    }, dispatch);
  }
}

export const fetchPermissionsList = () => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUser: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  try {
    const permissionsList = await getPermissionList(queryParams);

    await dispatch(updateSessionId(permissionsList[0].loggedInUserSessionId));

    await storePermissionsListInLocalStorage(permissionsList);

    await dispatch({
      type: 'users/fetchPermissionsListSuccess',
      payload: permissionsList
    });
  } catch (error) {
      await dispatchError(error,{
        type: 'users/fetchPermissionsListFailed',
        payload: error
      }, dispatch);
  }
}

export const storePermissionsListInLocalStorage = (permissionsList) => {
  localStorage.setItem('permissionsList', JSON.stringify(permissionsList));
}

export const restorePermissionsListFromLocalStorage = ()=> (dispatch, getState) => {
  const permissionsList = localStorage.getItem('permissionsList');

  dispatch({
    type: 'users/fetchPermissionsListSuccess',
    payload: JSON.parse(permissionsList)
  });
}

export const sendChangePassword = (currentPassword, newPassword, confirmPassword, changePasswordUser) =>  async (dispatch, getState) => {
  const state = getState();
  const formErrors = validateChangePasswordForm(newPassword, confirmPassword);

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData,
  }

  if (formErrors) {
    dispatch({
      type: 'users/changePasswordFailed',
      payload: {
        password: formErrors.password,
        confirmPassword: formErrors.confirmPassword
      }
    });
    return null;
  }

  try {
    const body = {
      'currentPwd': currentPassword,
      'newPwd': newPassword
    };

    const response = await changePwd(queryParams, body);

    dispatch ({
      type: 'users/changePasswordSuccess'
    });

    dispatch(updateSessionId(response.loggedInUserSessionId));
  } catch (error) {
    if (error.cause === 'INVALID_USERNAME_PASSWORD_ERROR') {
      const formError = {
        currentPassword: [
          INCORRECT_CURRENT_PASSWORD_ERROR
        ]
      };

      await dispatch ({
        type: 'users/changePasswordFailed',
        payload: formError
      });
    } else {
      await dispatchError(error,{
        type: 'users/changePasswordApiFailed',
        payload: error
      }, dispatch);
    }
  }
}


export const clearUserFormErrors = () => {
  return {
    type: 'users/clearUserFormErrors'
  }
}

export const clearSaveMyProfileErrors = () => {
  return {
    type: 'users/clearSaveMyProfileErrors'
  }
}

export const clearSaveUserProfileErrors = () => {
  return {
    type: 'users/clearSaveUserProfileErrors'
  }
}

export const clearCreateUserErrors = () => {
  return {
    type: 'users/clearCreateUserErrors'
  }
}

export const clearCreateUserAlerts = () => {
  return {
    type: 'users/clearCreateUserAlerts'
  }
}

export const clearChangePasswordSuccess = () => {
  return {
    type: 'users/clearChangePasswordSuccess'
  }
}

export const clearChangePasswordErrors = () => {
  return {
    type: 'users/clearChangePasswordErrors'
  }
}

export const clearSendInviteAlerts = () => {
  return {
    type: 'users/clearSendInviteAlerts'
  }
}

export const clearAllUserProfileResetPasswordAlerts = () => {
  return {
    type: 'users/clearSendUserProfileResetPasswordAlerts'
  }
}

export const clearSaveUserProfileAlerts = () => {
  return {
    type: 'users/clearSaveUserProfileAlerts'
  }
}

export const clearAllUserAlerts = () => {
  return {
    type: 'users/clearAllUserAlerts'
  }
}

export default function usersReducer(state = initialState, action) {
  const {type, payload} = action;
  switch (type) {
    case 'users/usersFetched':
      return {
        ...state,
        users: payload
      }
    case 'users/fetchUsersFailed':
      return {
        ...state,
        fetchUsersError: payload
      }
    case 'users/clearFetchUsersErrors':
      return {
        ...state,
        fetchUsersError: null
      }
    case 'users/setManagedUser':
      return {
        ...state,
        managedUser: payload
      }
    case 'users/getManagedUser':
      return {
        ...state,
        managedUser: payload
      }
    case 'users/clearManagedUser':
      return {
        ...state,
        managedUser: null
      }
    case 'users/saveMyProfileFailedValidation':
      return {
        ...state,
        userFormErrors: payload
      }
    case 'users/createUserFailedValidation':
      return {
        ...state,
        userFormErrors: payload
      }
    case 'users/fetchMyProfileSuccess':
      return {
        ...state,
        fetchMyProfileErrors: null,
        myProfile: payload,
      }
    case 'users/fetchMyProfileApiFailure':
    case 'users/fetchMyProfileError':
      return {
        ...state,
        fetchMyProfileErrors: payload
      }
    case 'users/fetchPermissionsListSuccess':
      return {
        ...state,
        permissionsList: payload,
        permissionListApiErrors: null
      }
    case 'users/fetchPermissionsListFailure':
      return {
        ...state,
        permissionsList: null,
        permissionListApiErrors: payload
      }
    case 'users/saveMyProfileApiSuccess':
      return {
        ...state,
        userFormErrors: null,
        myProfile: payload.myProfile,
        myUser: payload.myUser
      }
    case 'users/saveUserProfileApiSuccess':
      return {
        ...state,
        userFormErrors: null,
        saveUserProfileErrors: null,
        myProfile: payload.userProfile,
        saveUserProfileSuccess: true
      }
    case 'users/createUserApiSuccess':
      return {
        ...state,
        userFormErrors: null,
        createUserErrors: null,
        createdUser: payload.userProfile,
        createUserSuccess: true,
        createUserCurrentStep: 'permissions'
      }
    case 'users/saveUserPermissionsApiSuccess':
      return {
        ...state,
        saveUserPermissionsApiFailure: null,
        saveUserPermissionsApiSuccess: true,
        createUserCurrentStep: 'user-info'
      }
    case 'users/saveMyProfileApiFailure':
      return {
        ...state,
        saveMyProfileErrors: payload
      }
    case 'users/saveUserProfileApiFailure':
      return {
        ...state,
        saveUserProfileErrors: payload
      }
    case 'users/createUserApiFailure':
      return {
        ...state,
        userFormErrors: null,
        createUserErrors: payload
      }
    case 'users/saveUserPermissionsApiFailure':
      return {
        ...state,
        saveUserPermissionsApiFailure: payload,
        createUserCurrentStep: 'permissions',
        saveUserPermissionsApiSuccess: null
      }
    case 'users/changePasswordSuccess':
      return {
        ...state,
        changePasswordSuccess: true,
        changePasswordErrors: null,
        changePasswordApiErrors: null      }
    case 'users/changePasswordFailed':
      return {
        ...state,
        changePasswordErrors: payload
      }
    case 'users/changePasswordApiFailed':
      return {
        ...state,
        changePasswordApiErrors: payload
      }
    case 'users/clearUserFormErrors':
      return {
        ...state,
        userFormErrors: null
      }
    case 'users/clearSaveMyProfileErrors':
      return {
        ...state,
        saveMyProfileErrors: null
      }
    case 'users/clearSaveUserProfileErrors':
      return {
        ...state,
        saveUserProfileErrors: null
      }
    case 'users/clearCreateUserErrors':
      return {
        ...state,
        userFormErrors: null,
        createUserErrors: null
      }
    case 'users/clearSaveUserProfileAlerts':
      return {
        ...state,
        saveUserProfileErrors: null,
        saveUserProfileSuccess: null,
        sendUserProfileResetPasswordApiFailure: null,
        sendUserProfileResetPasswordError: null,
        sendUserProfileResetPasswordSuccess: null
      }
    case 'users/clearCreateUserAlerts':
      return {
        ...state,
        createUserErrors: null,
        createUserSuccess: null,
        saveUserPermissionsApiSuccess: null,
        saveUserPermissionsApiFailure: null
      }
    case 'users/clearChangePasswordSuccess':
    case 'users/clearChangePasswordErrors':
      return {
        ...state,
        changePasswordSuccess: null,
        changePasswordErrors: null,
        changePasswordApiErrors: null
      }
    case 'users/sendInvite':
      return {
        ...state,
        sendInviteSuccess: payload
      }
    case 'users/sendInviteApiFailed':
      return {
        ...state,
        sendInviteApiError: payload
      }
    case 'users/clearSendInviteAlerts':
      return {
        ...state,
        sendInviteSuccess: null,
        sendInviteApiError: null
      }
    case 'users/sendUserProfileResetPasswordSuccess':
      return {
        ...state,
        sendUserProfileResetPasswordSuccess: payload
      }
    case 'users/sendUserProfileResetPasswordError':
    case 'users/sendUserProfileResetPasswordApiFailure':
      return {
        ...state,
        sendUserProfileResetPasswordError: payload
      }
    case 'users/clearSendUserProfileResetPasswordAlerts':
      return {
        ...state,
        sendUserProfileResetPasswordSuccess: null,
        sendUserProfileResetPasswordError: null,
        sendUserProfileResetPasswordApiFailure: null,
      }
    case 'users/clearAllUserAlerts':
      return {
        ...state,
        sendUserProfileResetPasswordSuccess: null,
        sendUserProfileResetPasswordError: null,
        sendUserProfileResetPasswordApiFailure: null,
        sendInviteSuccess: null,
        sendInviteApiError: null,
        changePasswordSuccess: null,
        changePasswordErrors: null,
        changePasswordApiErrors: null,
        createUserErrors: null,
        createUserSuccess: null,
        saveUserPermissionsApiSuccess: null,
        saveUserPermissionsApiFailure: null,
        saveUserProfileErrors: null,
        saveUserProfileSuccess: null,
        fetchUsersError: null
      }
    default:
      return state;
  }
}
